import type { FunctionComponent } from 'react';
import React, { createContext } from 'react'
import { connectHits } from 'react-instantsearch-dom'

type ISearchHitsContext = { hits: any[] }

const SearchHitsContext = createContext({} as ISearchHitsContext)

const SearchHitsContextProviderRaw: FunctionComponent<React.PropsWithChildren<ISearchHitsContext>> = ({
  children,
  ...context
}) => {
  return (
    <SearchHitsContext.Provider value={context}>
      {children}
    </SearchHitsContext.Provider>
  )
}

export const SearchHitsContextProvider = connectHits(
  SearchHitsContextProviderRaw
)

export const useSearchHits = () => {
  const context = React.useContext(SearchHitsContext)
  return context?.hits ?? []
}
